Vue.component('chat-video-rainbow', {
    props: ['options'],
    template:	'<transition v-if="isActive" name="bounce" enter-active-class="bounceInLeft" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
        '<div id="video" :class="{ \'escalation\': hasEscalation }">'+
        '</div>'+
        '</transition>',


    data: function(){
        return {
            isActive:false,
            hasEscalation:false,
            msg:'',
            isAllowClose:false,
            inTransfer:false

        }
    },
    mounted: function() {
        var that = this;
        bus.$on('onRainbowVideoEscalation', function (val) {
            that.contentShow(val);
            that.setEscalation(val)
        });

        this.$parent.$on('onRainbowVideoEscalation', function (val) {
            that.contentShow(val);
            that.setEscalation(val)
        });
    },

    methods:{
        contentShow:function(val){
            this.isActive = val;
        },

        setEscalation:function(val){
            this.hasEscalation = val;
        },
    }
});
